import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Home, Sun, Moon, Info, Mail, BookOpen, HelpCircle, LifeBuoy, Cake, Percent } from 'lucide-react'
import Toggle from '../atoms/Toggle'
import { useSelector, useDispatch } from 'react-redux'
import { toggleTheme } from '../store/slices/themeSlice'
import ClusterNavItem from '../components/ClusterNavItem'
import { AGE_HUB, AGE_SPOKES } from '../constants/ageTools'
import { PERCENTAGE_HUB, PERCENTAGE_SPOKES } from '../constants/percentageTools'
import './Sidebar.css'

const AGE_CLUSTER_PATHS = new Set([AGE_HUB.path, ...AGE_SPOKES.map(s => s.path)])
const PERCENTAGE_CLUSTER_PATHS = new Set([PERCENTAGE_HUB.path, ...PERCENTAGE_SPOKES.map(s => s.path)])

const Sidebar = ({ tools = [], className = '', ...props }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const { isDarkTheme } = useSelector(state => state.theme)

  const handleThemeToggle = () => {
    dispatch(toggleTheme())
  }

  const classes = [
    'sidebar',
    className
  ].filter(Boolean).join(' ')

  // Age hub + spokes render separately via AgeToolsNavGroup (collapsible),
  // so exclude them from the regular flat tools list to avoid duplicates.
  const nonAgeTools = tools.filter(tool => !AGE_CLUSTER_PATHS.has(tool.path) && !PERCENTAGE_CLUSTER_PATHS.has(tool.path))

  return (
    <aside className={classes} {...props}>
      <div className="sidebar-header">
        <p className="sidebar-title">EveryKits</p>
        <p className="sidebar-subtitle">Digital Utility Belt</p>
      </div>

      <nav className="sidebar-nav">
        <ul className="sidebar-nav-list">
          <li className="sidebar-nav-item">
            <Link
              to="/"
              className={['sidebar-nav-link', location.pathname === '/' && 'sidebar-nav-link-active'].filter(Boolean).join(' ')}
            >
              <span className="sidebar-nav-icon">
                <Home size={20} />
              </span>
              <span className="sidebar-nav-text">Home</span>
            </Link>
          </li>

          <ClusterNavItem hub={AGE_HUB} spokes={AGE_SPOKES} icon={Cake} />
          <ClusterNavItem hub={PERCENTAGE_HUB} spokes={PERCENTAGE_SPOKES} icon={Percent} />

          {nonAgeTools.map((tool) => (
            <li key={tool.path} className="sidebar-nav-item">
              <Link
                to={tool.path}
                className={['sidebar-nav-link', location.pathname === tool.path && 'sidebar-nav-link-active'].filter(Boolean).join(' ')}
              >
                <span className="sidebar-nav-icon">
                  <tool.icon size={20} />
                </span>
                <span className="sidebar-nav-text">{tool.name}</span>
              </Link>
            </li>
          ))}
          <li className="sidebar-nav-separator"></li>
          <li className="sidebar-nav-item">
            <Link
              to="/blog/"
              className={['sidebar-nav-link', (location.pathname === '/blog' || location.pathname.startsWith('/blog/')) && 'sidebar-nav-link-active'].filter(Boolean).join(' ')}            >
              <span className="sidebar-nav-icon">
                <BookOpen size={20} />
              </span>
              <span className="sidebar-nav-text">Blog</span>
            </Link>
          </li>
          <li className="sidebar-nav-item">
            <Link
              to="/faq/"
              className={['sidebar-nav-link', location.pathname === '/faq' && 'sidebar-nav-link-active'].filter(Boolean).join(' ')}            >
              <span className="sidebar-nav-icon">
                <HelpCircle size={20} />
              </span>
              <span className="sidebar-nav-text">FAQ</span>
            </Link>
          </li>
          <li className="sidebar-nav-item">
            <Link
              to="/help/"
              className={['sidebar-nav-link', location.pathname === '/help' && 'sidebar-nav-link-active'].filter(Boolean).join(' ')}            >
              <span className="sidebar-nav-icon">
                <LifeBuoy size={20} />
              </span>
              <span className="sidebar-nav-text">Help</span>
            </Link>
          </li>
          <li className="sidebar-nav-item">
            <Link
              to="/about/"
              className={['sidebar-nav-link', location.pathname === '/about' && 'sidebar-nav-link-active'].filter(Boolean).join(' ')}            >
              <span className="sidebar-nav-icon">
                <Info size={20} />
              </span>
              <span className="sidebar-nav-text">About</span>
            </Link>
          </li>
          <li className="sidebar-nav-item">
            <Link
              to="/contact/"
              className={['sidebar-nav-link', location.pathname === '/contact' && 'sidebar-nav-link-active'].filter(Boolean).join(' ')}            >
              <span className="sidebar-nav-icon">
                <Mail size={20} />
              </span>
              <span className="sidebar-nav-text">Contact</span>
            </Link>
          </li>
        </ul>
      </nav>

      {/* <div className="sidebar-footer">
        <div className="sidebar-theme-toggle">
          <span className="sidebar-theme-label">
            {isDarkTheme ? <Moon size={16} /> : <Sun size={16} />}
          </span>
          <Toggle 
            checked={!isDarkTheme}
            onChange={handleThemeToggle}
          />
        </div>
      </div> */}
    </aside>
  )
}

export default Sidebar